<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>
        <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
            <!--begin::sidebar-->
            <sidebar-component classMenu="AccidentAdd"></sidebar-component>
            <!--end::sidebar-->

            <div class="page-wrapper">
                <!--begin::navbar-->
                <navbar-component></navbar-component>
                <!--end::navbar-->

                <!--begin::content-->
                <div class="page-content">
                    <div class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            ">
                        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                                    &nbsp;&nbsp;&nbsp;
                                    <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                                        Pengajuan Claim
                                    </h6>
                                    <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                                        <i class="link-icon" data-feather="repeat"></i>
                                        {{ $t("resetFormTxt") }}
                                    </button>
                                </div>
                                <div class="card-body">
                                    <!--begin::loading-data-->
                                    <div v-if="isLoading" class="d-flex align-items-center">
                                        <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                        <strong>{{ $t("loadingTxt") }}...</strong>
                                    </div>
                                    <!--end::loading-data-->

                                    <form ref="formElement" class="forms-sample" @submit.prevent="submitData"
                                        method="POST">
                                        <div class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "></div>




                                        <!-- DATA ORDER -->
                                        <div class="card mb-3">
                                            <div class="card-header ">DATA ORDER</div>
                                            <div class="card-body">
                                                <div class="row mb-2">
                                                    <div class="col-md-3">
                                                        <label>Load Id</label>

                                                        <multiselect @open="removeReadonly" v-model="dataOrder.loadId"
                                                            @search-change="asyncSearchLoadId" @input="selectChangeLoad"
                                                            :options="fetchLoadId" placeholder="Type to search "
                                                            track-by="load_id" label="load_id"><span
                                                                slot="noResult">Oops! No elements found. Consider
                                                                changing the
                                                                search query.</span></multiselect>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Jenis Truck</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.type_truck" disabled>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>NMK Driver</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.nmkDriver" disabled>



                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Nopol</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.nopol" disabled>
                                                    </div>
                                                </div>
                                                <div class="row mb-2">
                                                    <div class="col-md-3">
                                                        <label>Nama Driver</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.namaDriver" disabled>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Driver Deposit</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.driver_deposit" disabled>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Carrier</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.carrier" disabled>
                                                    </div>
                                                </div>

                                                <!-- Table Data Order -->

                                                <div class="d-flex justify-content-end mb-2">
                                                    <span class="btn-success btn-sm  cursor-pointer"
                                                        @click="tambahOrder">
                                                        <i class="mdi mdi-plus"></i>
                                                    </span>
                                                </div>

                                                <div class="table-responsive">
                                                    <table class="table table-bordered mt-3">
                                                        <thead class="table-light">
                                                            <tr>
                                                                <th>Action</th>
                                                                <th>Order No</th>
                                                                <th>Customer Code</th>
                                                                <th>Customer Name</th>
                                                                <th>Sap Code</th>
                                                                <th>Tanggal Order</th>
                                                                <th>Pick Plan</th>
                                                                <th>Pick Name</th>
                                                                <th>Drop Plan</th>
                                                                <th>Drop Name</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, idx) in dataOrder.orders" :key="idx">
                                                                <!-- Action -->
                                                                <td class="text-nowrap">
                                                                    <!-- Tombol hapus -->
                                                                    <span class="btn-danger btn-sm me-1 cursor-pointer"
                                                                        @click="hapusOrder(idx)">
                                                                        <i class="mdi mdi-delete"></i>
                                                                    </span>

                                                                    <!-- Checklist sebelum selesai -->
                                                                    <span
                                                                        class="btn-success btn-sm mr-5  cursor-pointer"
                                                                        v-if="!item.done" @click="item.done = true"
                                                                        title="Tandai selesai">
                                                                        <i class="mdi mdi-check"></i>
                                                                    </span>


                                                                    <span class="btn-danger btn-sm  cursor-pointer"
                                                                        v-else @click="item.done = false" title="">
                                                                        <i class="mdi mdi-close" title="Selesai"></i>
                                                                    </span>

                                                                    <!-- Checklist sesudah selesai -->

                                                                </td>

                                                                <!-- Order No -->
                                                                <td>
                                                                    <!-- v-select kalau belum selesai -->
                                                                    <!-- <v-select
                                                                        v-if="!item.done"
                                                                        :options="orderNoList"
                                                                        label="text"
                                                                        :reduce="o => o.value"
                                                                        v-model="item.orderNo"
                                                                        @input="pilihOrder(idx)"
                                                                    ></v-select> -->

                                                                    <multiselect v-if="!item.done"
                                                                        v-model="item.orderNo"
                                                                        @input="pilihOrder(idx, item.orderNo)"
                                                                        :options="orderNoList"
                                                                        placeholder="Type to search "
                                                                        track-by="order_no" label="order_no">

                                                                    </multiselect>

                                                                    <!-- teks kalau sudah selesai -->
                                                                    <span v-else>{{ item.orderNo.order_no }}</span>
                                                                </td>

                                                                <td>{{ item.customerCode }}</td>
                                                                <td>{{ item.customerName }}</td>
                                                                <td>{{ item.sapCode }}</td>
                                                                <td>{{ item.tanggalOrder }}</td>
                                                                <td>{{ item.pickPlan }}</td>
                                                                <td>{{ item.pickName }}</td>
                                                                <td>{{ item.dropPlan }}</td>
                                                                <td>{{ item.dropName }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>

                                        <!-- DATA KLAIM -->
                                        <div class="card mb-3">
                                            <div class="card-header">DATA KLAIM</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <!-- Kolom kiri -->
                                                    <div class="col-md-6">
                                                        <div class="row mb-2">
                                                            <div class="col-md-4">
                                                                <label>Aging (D)</label>
                                                                <input disabled type="text"
                                                                    class="form-control form-control-sm"
                                                                    v-model="dataKlaim.aging">
                                                            </div>
                                                            <div class="col-md-8">
                                                                <label>No Klaim</label>
                                                                <input disabled type="text"
                                                                    class="form-control form-control-sm"
                                                                    v-model="dataKlaim.noKlaim">
                                                            </div>
                                                        </div>

                                                        <div class="mb-2">
                                                            <label>Cabang</label>
                                                            <input disabled type="text"
                                                                class="form-control form-control-sm" di
                                                                v-model="this.dataOrder.branch_name">
                                                        </div>

                                                        <div class="row mb-2">
                                                            <div class="col-md-6">
                                                                <label>NMK Driver</label>
                                                                <!-- <select class="form-select form-select-sm"
                                                                    v-model="dataKlaim.nmkDriver">
                                                                    <option>NMK5678 / N7th</option>
                                                                </select> -->

                                                                <multiselect v-model="dataKlaim.nmkDriver"
                                                                    ref="inputtLoadId"
                                                                    @search-change="asyncSearchNmkDriver"
                                                                    @input="selectNmkDriver" :options="fetchNmkDriver"
                                                                    placeholder="Type to search " track-by="nmk"
                                                                    label="nmk"><span slot="noResult">Oops! No elements
                                                                        found. Consider changing the
                                                                        search query.</span>
                                                                </multiselect>

                                                            </div>
                                                            <div class="col-md-6">
                                                                <label>Nama Driver</label>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    v-model="dataKlaim.namaDriver" disabled>



                                                            </div>
                                                        </div>

                                                        <div class="row mb-2">
                                                            <div class="col-md-6">
                                                                <label>Nopol</label>
                                                                <!-- <select class="form-select form-select-sm"
                                                                    v-model="dataKlaim.nopol">
                                                                    <option>B8967SCQ</option>
                                                                </select> -->

                                                                <multiselect v-model="dataKlaim.nopol"
                                                                    @search-change="asyncSearchNopol"
                                                                    @input="selectNopol" :options="fetchNopol"
                                                                    placeholder="Type to search " track-by="vehicle_no"
                                                                    label="vehicle_no"><span slot="noResult">Oops! No
                                                                        elements found. Consider changing the
                                                                        search query.</span></multiselect>



                                                            </div>
                                                            <div class="col-md-6">
                                                                <label>Jenis Truck</label>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    v-model="dataKlaim.type_truck" disabled>
                                                            </div>
                                                        </div>

                                                        <div class="row mb-2">
                                                            <div class="col-md-12">
                                                                <label>Tanggal Kejadian</label>
                                                                <!-- <input type="date" class="form-control form-control-sm"
                                                                    v-model="dataKlaim.tglKejadian"> -->

                                                                <date-range-picker style="width: 100%"
                                                                    :locale-data="locale"
                                                                    v-model="dataKlaim.tglKejadian" opens="center"
                                                                    :singleDatePicker="true" :timePicker="true"
                                                                    :maxDate="new Date()">
                                                                </date-range-picker>

                                                            </div>
                                                            <!-- <div class="col-md-6">
                                                                <label>Jam</label>
                                                                <input type="time" class="form-control form-control-sm"
                                                                    v-model="dataKlaim.jamKejadian">
                                                            </div> -->
                                                        </div>

                                                        <div>
                                                            <label>Tanggal Pengajuan</label>
                                                            <!-- <input type="date" class="form-control form-control-sm"
                                                                v-model="dataKlaim.tglPengajuan"> -->
                                                            <date-range-picker style="width: 100%"
                                                                :locale-data="localeP" :maxDate="new Date()"
                                                                v-model="dataKlaim.tglPengajuan" opens="center"
                                                                :singleDatePicker="true" :timePicker="false">
                                                            </date-range-picker>
                                                        </div>
                                                    </div>

                                                    <!-- Kolom kanan -->
                                                    <div class="col-md-6">
                                                        <div class="mb-2">
                                                            <label>Status Klaim</label>
                                                            <input type="text" class="form-control form-control-sm"
                                                                v-model="dataKlaim.status" readonly>
                                                        </div>

                                                        <div class="mb-2">
                                                            <label>Sumber Informasi</label>
                                                            <!-- <select class="form-select form-select-sm"
                                                                v-model="dataKlaim.sumberInfo">
                                                                <option>Customer</option>
                                                                <option>Vendor</option>
                                                            </select> -->

                                                            <v-select :options="fetchSumberInformasi"
                                                                v-model="dataKlaim.sumberInfo"
                                                                v-bind:style="{ padding: 0 }" class="form-control"
                                                                label="code" return-object></v-select>
                                                        </div>

                                                        <div class="mb-2">
                                                            <label>Laporan Kejadian</label>


                                                            <ckeditor v-model="dataKlaim.laporan"
                                                                :config="editorConfigLaporan"  :key="'laporan'" ></ckeditor>


                                                            <!-- <TinymceEditor
                                                                    v-model="dataKlaim.laporan"
                                                                    :init=" {
                                                                        base_url: '/tinymce', // folder public/tinymce
                                                                        suffix: '.min',
                                                                        plugins: 'image link media code table',
                                                                        toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright | image link media code table',
                                                                        menubar: 'file edit view insert format tools table help',
                                                                        readonly: false
                                                                    }"
                                                                /> -->



                                                        </div>

                                                        <div class="mt-2">
                                                            <label>Hasil Pemeriksaan</label>
                                                            <ckeditor v-model="dataKlaim.pemeriksaan"
                                                                :config="editorConfigPemeriksaan"  :key="'pemeriksaan'" ></ckeditor>
                                                            <!-- <input type="text" class="form-control form-control-sm"
                                                                v-model="dataKlaim.pemeriksaan"> -->

                                                            <!-- <TinymceEditor
                                                                    v-model="dataKlaim.pemeriksaan"
                                                                    :init=" {
                                                                        base_url: '/tinymce', // folder public/tinymce
                                                                        suffix: '.min',
                                                                        plugins: 'image link media code table',
                                                                        toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright | image link media code table',
                                                                        menubar: 'file edit view insert format tools table help',
                                                                        readonly: false
                                                                    }"
                                                                /> -->
                                                            <!-- <vue2-tinymce-editor  :key="'editor-pemeriksaan'" id="editor-pemeriksaan" v-model="dataKlaim.pemeriksaan"></vue2-tinymce-editor> -->
                                                        </div>

                                                        <div class="mt-2">
                                                            <label>Penyelesaian</label>
                                                            <ckeditor v-model="dataKlaim.penyelesaian"  :key="'penyelesaian'" 
                                                                :config="editorConfigPenyelesaian"></ckeditor>

                                                                
                                                            <!-- <TinymceEditor
                                                                    v-model="dataKlaim.penyelesaian"
                                                                    :init=" {
                                                                        base_url: '/tinymce', // folder public/tinymce
                                                                        suffix: '.min',
                                                                        plugins: 'image link media code table',
                                                                        toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright | image link media code table',
                                                                        menubar: 'file edit view insert format tools table help',
                                                                        readonly: false
                                                                    }"
                                                                /> -->
                                                            <!-- <vue2-tinymce-editor  :key="'editor-penyelesaian'" id="editor-penyelesaian" v-model="dataKlaim.penyelesaian"></vue2-tinymce-editor>
                                                             -->
                                                        </div>



                                                        <div class="mt-2">
                                                            <label>Catatan</label>
                                                            <textarea v-model="dataKlaim.catatan" class="form-control"
                                                                rows="3" disabled></textarea>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <!-- DETAIL KLAIM -->
                                        <div class="card mb-3">
                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                <span>DETAIL KLAIM</span>
                                                <span class="btn btn-success btn-sm" @click="tambahDetail">
                                                    <i class="mdi mdi-plus"></i>
                                                </span>
                                            </div>

                                            <div class="card-body">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered align-middle">
                                                        <thead class="table-light text-center">
                                                            <tr>
                                                                <th style="width: 40px;">No</th>
                                                                <th style="width: 70px;">Action</th>
                                                                <th>Produk</th>
                                                                <th>Keterangan</th>
                                                                <th>Klaim ke</th>
                                                                <th>Kategori</th>
                                                                <th style="width: 100px;">Jumlah</th>
                                                                <th>Type Paket</th>
                                                                <th style="width: 120px;">Harga per Paket</th>
                                                                <th>Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(detail, idx) in dataKlaim.details" :key="idx">
                                                                <td class="text-center">{{ idx + 1 }}</td>
                                                                <td class="text-center">
                                                                    <span class="btn btn-danger btn-sm"
                                                                        @click="hapusDetail(idx)">
                                                                        <i class="mdi mdi-delete"></i>
                                                                    </span>
                                                                </td>
                                                                <td><input class="form-control form-control-sm"
                                                                        v-model="detail.produk"></td>
                                                                <td><input class="form-control form-control-sm"
                                                                        v-model="detail.keterangan"></td>
                                                                <td>
                                                                    <select class="form-select form-select-sm"
                                                                        v-model="detail.klaimKe">
                                                                        <option value="Vendor">Vendor</option>
                                                                        <option value="Driver">Driver</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <v-select :options="fetchCategoryStatus"
                                                                        v-model="detail.kategori"
                                                                        v-bind:style="{ padding: 0 }"
                                                                        class="form-control" label="code"
                                                                        return-object></v-select>
                                                                </td>
                                                                <td>
                                                                    <input class="form-control form-control-sm text-end"
                                                                        type="number" v-model.number="detail.jumlah">
                                                                </td>
                                                                <td>
                                                                    <!-- <select class="form-select form-select-sm"
                                                                        v-model="detail.typePaket">
                                                                        <option value="Kilogram">Kilogram</option>
                                                                        <option value="Karton">Karton</option>
                                                                    </select> -->

                                                                    <v-select :options="fetchTypePaket"
                                                                        v-model="detail.typePaket"
                                                                        v-bind:style="{ padding: 0 }"
                                                                        class="form-control" label="code"
                                                                        return-object>
                                                                    </v-select>

                                                                </td>
                                                                <td><input class="form-control form-control-sm text-end"
                                                                        type="number" v-model.number="detail.harga">
                                                                </td>
                                                                <td> {{ formatCurrency(detail.jumlah * detail.harga) }}
                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>


                                                <!-- Ringkasan Klaim -->
                                                <div class="row mt-3">
                                                    <div class="col-md-4 offset-md-8">
                                                        <div class="mb-2 d-flex justify-content-between">
                                                            <label><strong>Total Klaim</strong></label>
                                                            <input class="form-control form-control-sm text-end"
                                                                :value="formatCurrency(totalKlaim)" readonly>
                                                        </div>
                                                        <div class="mb-2 d-flex justify-content-between">
                                                            <label>Beban Klaim Vendor</label>
                                                            <input type="number"
                                                                class="form-control form-control-sm text-end"
                                                                v-model="bebanVendor">
                                                        </div>
                                                        <div class="mb-2 d-flex justify-content-between">
                                                            <label>Beban Klaim Driver</label>
                                                            <input type="number"
                                                                class="form-control form-control-sm text-end"
                                                                v-model="bebanDriver">
                                                        </div>
                                                        <div class="d-flex mb-2 justify-content-between">
                                                            <label>Beban Klaim LINC</label>
                                                            <input type="number"
                                                                class="form-control form-control-sm text-end"
                                                                v-model="bebanKantor">
                                                        </div>

                                                        <div class="d-flex justify-content-between">
                                                            <label>Beban Klaim Asuransi</label>
                                                            <input type="number"
                                                                class="form-control form-control-sm text-end"
                                                                v-model="bebanAsuransi">
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <!-- LAMPIRAN -->
                                        <div class="card mb-3">
                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                <span>Lampiran</span>
                                                <span class="btn btn-success btn-sm" @click="tambahClaimFile">
                                                    <i class="mdi mdi-plus"></i>
                                                </span>
                                            </div>
                                            <div class="card-body">
                                                <table class="table table-bordered">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th style="width: 50px;">No</th>
                                                            <th style="width: 70px;">Action</th>
                                                            <th>Nama</th>
                                                            <th>File</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(lamp, idx) in lampiran" :key="idx">
                                                            <td class="text-center">{{ idx + 1 }}</td>
                                                            <td class="text-center">
                                                                <span class="btn btn-danger btn-sm"
                                                                    @click="hapusClaimFile(idx)">
                                                                    <i class="mdi mdi-delete"></i>
                                                                </span>
                                                                <a v-if="lamp.file != null" :href=lamp.file
                                                                    class="btn btn-sm" target="_blank"><i
                                                                        class="mdi mdi-download"></i></a>
                                                            </td>
                                                            <td>
                                                                <input class="form-control" v-model="lamp.nama">
                                                            </td>
                                                            <td>
                                                                <input type="file" class="form-control"
                                                                    @change="onFileChange($event, idx)">
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
















                                        <div class="card-footer">
                                            <button class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        " @click="backForm" type="button">
                                                <i class="link-icon" data-feather="arrow-left"></i>
                                                {{ $t("backMess") }}
                                            </button>
                                            &nbsp;&nbsp;&nbsp;
                                            <button class="btn btn-primary float-end btn-sm" type="submit">
                                                <i class="link-icon" data-feather="save"></i>
                                                {{ $t("submitFormTxt") }}
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                            <!--end::card-->
                        </div>
                    </div>
                </div>
                <!--end::content-->
                <!-- <modal-unloading :showModal="showModalUnloading" :data="this.dataModal" @closeModal="closeMyModal">
                </modal-unloading> -->

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>





<script>


import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from '@/middleware/mixinAddress.js';
// import Datepicker from "vuejs-datepicker";
import multiselect from "vue-multiselect";
import moment from 'moment'
// import modalUnloading from "@/components/modal/modalUnloading.vue";
// import CurrencyInput from "@/components/_partials/inputCurrency";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
    name: "PengajuanAdd",
    props: {},
    mixins: [myMixinAddress],
    components: {
        "sidebar-component": sidebarComponent,
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        // "modal-unloading": modalUnloading,
        multiselect: multiselect,
        DateRangePicker,
        // CurrencyInput,
        // Datepicker
    },
    data() {
        const startDate = new Date();
        const endDate = new Date();

        return {
            disabledBeforeLoad: true,
            vehicle_no: "",
            bebanVendor: 0,
            bebanKantor: 0,
            bebanDriver: 0,
            bebanAsuransi:0,

            fetchVehicleNo: [],
            opens: "center",


            category: '',
            fetchCategory: [],
            fetchCategoryStatus: [],
            fetchTypePaket:[],

            orderNoList: [

            ],
            isEditorDisabled: true,
            editorData: '<p>Halo, ini CKEditor 4 gratis!</p>',
            editorConfig: {
                versionCheck: false,
                toolbar: [
                    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'Undo', 'Redo'] },
                    { name: 'editing', items: ['Find', 'Replace', 'SelectAll'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Smiley'] },
                    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'tools', items: ['Maximize', 'ShowBlocks', 'Source'] }
                ]
            },


            editorConfigLaporan: {
                versionCheck: false,
                toolbar: [
                    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'Undo', 'Redo'] },
                    { name: 'editing', items: ['Find', 'Replace', 'SelectAll'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Smiley'] },
                    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'tools', items: ['Maximize', 'ShowBlocks', 'Source'] }
                ]
            },


            editorConfigPemeriksaan: {
                versionCheck: false,
                toolbar: [
                    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'Undo', 'Redo'] },
                    { name: 'editing', items: ['Find', 'Replace', 'SelectAll'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Smiley'] },
                    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'tools', items: ['Maximize', 'ShowBlocks', 'Source'] }
                ]
            },


            editorConfigPenyelesaian: {
                versionCheck: false,
                toolbar: [
                    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'Undo', 'Redo'] },
                    { name: 'editing', items: ['Find', 'Replace', 'SelectAll'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Smiley'] },
                    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'tools', items: ['Maximize', 'ShowBlocks', 'Source'] }
                ]
            },


            fetchSumberInformasi: [],
            // dataOrder: {
            //     orders: []
            // },

            driver_nmk: "",
            fetchDriverNmk: [],
            fetchAccidentArea: [],
            fetchHaul: ['Short Haul', 'Long Haul'],
            haul: '',
            penyebab_langsung: '',
            accident_area: '',
            fetchPenyebabLangsung: [],
            caused: '',
            fetchCaused: [],

            fetchKerusakan: [],
            kerusakans: '',
            fetchTipeKejadian: [],
            tipe_kejadians: '',
            fetchPenyebabDasar: [],
            penyebab_dasars: '',

            locale: {
                format: "dd mmm yyyy H:MM:ss",
                separator: ' - ',
            },

            localeP: {
                format: "dd mmm yyyy",
                separator: ' - ',
            },

            accident_date: {
                startDate,
                endDate,
            },

            active_date: {
                startDate: null,
                endDate: null
            },

            fetchNmkDriver: [],
            fetchNopol: [],

            accident_date_complete: {
                startDate: null,
                endDate: null
            },


            fetchCaseResult: [],
            case_result: "",

            rate: '',
            fetchRate: [],

            fetchLoadNumber: [],
            loadNumber: [],

            fetchDirectCauseDetail: [],
            directCauseDetail: "",

            fetchProvinsiTujuan: [],
            ProvinsiTujuan: [],

            fetchKotaTujuan: [],
            KotaTujuan: [],

            fetchSubCustomer: ['Industrial', 'Consumer', 'MT', 'Pallet', 'E-COM'],
            SubCustomer: [],

            showModalUnloading: false,

            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            permision_role: [],
            userData: "",
            companyCode: "",
            forms: {

            },


            disabledDate: {},
            dataModal: {},
            fetchLoadId: [],
            load_id: "",


            dataOrder: {
                loadId: '',
                type_truck: '',
                nmkDriver: '',
                driver_deposit: '',
                driver_number: '',
                nopol: '',
                namaDriver: '',
                carrier: '',
                branch_name: '',
                orders: [

                ]
            },
            dataKlaim: {
                aging: 0,
                status: 'NEW',
                noKlaim: '',
                sumberInfo: 'Customer',
                cabang: 'Jakarta',
                laporan: '',
                nmkDriver: '',
                namaDriver: '',
                tglKejadian: {
                    startDate,
                    endDate,
                },
                tglPengajuan: {
                    startDate,
                    endDate,
                },
                pemeriksaan: '',
                penyelesaian: '',
                details: [
                    { produk: '', keterangan: '', klaimKe: 'Vendor', kategori: 'Claim DG', jumlah: 0, typePaket: 'Kilogram', harga: 0 }
                ]
            },
            lampiran: [
                { nama: 'Berita Acara', file: null }
            ]

        };
    },



    watch: {
        'dataKlaim.tglPengajuan'(newDate) {
            if (!newDate.startDate) {
                this.dataKlaim.aging = '';
                return;
            }

            const today = new Date();
            const selectedDate = new Date(newDate.startDate);

            // reset jam ke 00:00:00
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);

            // hitung selisih dalam hari (selalu positif)
            const diffTime = Math.abs(selectedDate - today);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            this.dataKlaim.aging = diffDays;
        },


        'dataKlaim.laporan'(val) {
            if (this.$refs.editorLaporan) {
                this.$refs.editorLaporan.editor.setData(val || '');
            }
        },
        'dataKlaim.pemeriksaan'(val) {
            if (this.$refs.editorPemeriksaan) {
                this.$refs.editorPemeriksaan.editor.setData(val || '');
            }
        },
        'dataKlaim.penyelesaian'(val) {
            if (this.$refs.editorPenyelesaian) {
                this.$refs.editorPenyelesaian.editor.setData(val || '');
            }
        }
    },
    computed: {
        totalKlaim() {
            return this.dataKlaim.details.reduce((sum, d) => sum + (d.jumlah * d.harga), 0);
        }
    },
    methods: {
        toggleEditor() {
            this.isEditorDisabled = !this.isEditorDisabled; // Example: Toggle disabled state
        },
        selectNmkDriver(ev) {
            console.log(ev);
            this.dataKlaim.namaDriver = ev.driver_name
        },

        selectNopol(ev) {
            this.dataKlaim.type_truck = ev.type_truck;
        },
        openMap() {

        },
        changeDisabled(ev) {
            this.forms.complete_date = "";
            this.disabledDate = {
                to: ev,
            }
        },
        clearLoad() {


        },

        formatCurrency(value) {
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR'
            }).format(value || 0);
        },

        loadVehicleNo() {
            const baseURI =
                this.$settings.endPointCt + `master-truck`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchVehicleNo = response.data.datas.data;
            });
        },

        loadDriverNmk() {
            const baseURI =
                this.$settings.endPointCt + `master-driver`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDriverNmk = response.data.datas.data;

            });
        },

        selectDriverNmk(driver) {
            this.forms.vehicle_owner = driver.branch_name;
        },

        selectAccidentArea(accident) {
            if (this.forms.vehicle_owner == accident) {
                this.haul = "Short Haul";
            }
        },

        loadSumberInformasi() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=sumInf`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchSumberInformasi = response.data.datas;

            });
        },

        tambahDetail() {
            this.dataKlaim.details.push({
                produk: '',
                keterangan: '',
                klaimKe: 'Vendor',
                kategori: 'Claim DG',
                jumlah: 0,
                typePaket: 'Kilogram',
                harga: 0
            });
        },
        hapusDetail(index) {
            this.dataKlaim.details.splice(index, 1);
        },



        loadCause() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=cauac`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchCaused = response.data.datas;
            });
        },

        loadRate() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=ratac`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchRate = response.data.datas;
            });
        },

        loadPenyebabLangsung() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=dirca`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchPenyebabLangsung = response.data.datas;
            });
        },

        loadDirectCauseDetail() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=penla`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDirectCauseDetail = response.data.datas;
            });
        },
        loadCaseResult() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=casre`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchCaseResult = response.data.datas;
            });
        },

        selectChangeLoad(ev) {
            console.log(ev);
            this.dataOrder.type_truck = ev.type_truck;
            this.dataOrder.nmkDriver = ev.driver_id;
            this.dataOrder.nopol = ev.vehicle_no;
            this.dataOrder.namaDriver = ev.driver_name;
            this.dataOrder.carrier = ev.carrier
            this.dataOrder.driver_number = ev.driver_number;
            this.dataOrder.branch_name = ev.branch_name;
            this.dataKlaim.nmkDriver = {
                nmk: ev.driver_id,
                driver_name: ev.driver_nameselectC
            }

            this.dataKlaim.namaDriver = ev.driver_name;


            this.dataKlaim.nopol = {
                vehicle_no: ev.vehicle_no,
                type_truck: ev.type_truck

            }

            this.dataKlaim.type_truck = ev.type_truck;

            this.loadordeNo(ev.load_id)
            if (ev.driver_id != null) {
                this.loadDriverDeposit(ev.driver_id)
            }

        },

        asyncSearchNmkDriver(ev) {
            const baseURI =
                this.$settings.endPointCt + `driver-nmk/get-data-nmks?limit=999999&nmk=${ev}`;
            return this.$http.get(baseURI).then((response) => {


                let datas = [];

                if (Array.isArray(response.data.datas)) {
                    datas = response.data.datas;
                } else if (Array.isArray(response.data.datas?.data)) {
                    datas = response.data.datas.data;
                } else if (response.data.datas) {
                    datas = [response.data.datas];
                }



                this.fetchNmkDriver = datas.map(item => ({
                    driver_name: item.driver_name,
                    nmk: item.nmk,
                    driver_nmk_id: item.driver_nmk_id,
                    driver_number: item.driver_number,
                    master_driver_id: item.master_driver_id,
                }));
            });
        },

        loadNmkDriver() {
            const baseURI =
                this.$settings.endPointCt + `driver-nmk/get-data-nmks?limit=999999`;
            return this.$http.get(baseURI).then((response) => {

                let datas = [];

                if (Array.isArray(response.data.datas)) {
                    datas = response.data.datas;
                } else if (Array.isArray(response.data.datas?.data)) {
                    datas = response.data.datas.data;
                } else if (response.data.datas) {
                    datas = [response.data.datas];
                }



                this.fetchNmkDriver = datas.map(item => ({
                    driver_name: item.driver_name,
                    nmk: item.nmk,
                    driver_nmk_id: item.driver_nmk_id,
                    driver_number: item.driver_number,
                    master_driver_id: item.master_driver_id,
                }));


            });
        },


        asyncSearchNopol(ev) {
            const baseURI =
                this.$settings.endPointCt + `master-truck?limit=10&vehicle_no=${ev}`;
            return this.$http.get(baseURI).then((response) => {

                let datas = [];

                if (Array.isArray(response.data.datas)) {
                    datas = response.data.datas;
                } else if (Array.isArray(response.data.datas?.data)) {
                    datas = response.data.datas.data;
                } else if (response.data.datas) {
                    datas = [response.data.datas];
                }

                this.fetchNopol = datas.map(item => ({
                    vehicle_no: item.vehicle_no,
                    type_truck: item.type_truck,
                }));

            });
        },

        loadNopol() {
            const baseURI =
                this.$settings.endPointCt + `master-truck?limit=10`;
            return this.$http.get(baseURI).then((response) => {
                let datas = [];

                if (Array.isArray(response.data.datas)) {
                    datas = response.data.datas;
                } else if (Array.isArray(response.data.datas?.data)) {
                    datas = response.data.datas.data;
                } else if (response.data.datas) {
                    datas = [response.data.datas];
                }

                this.fetchNopol = datas.map(item => ({
                    vehicle_no: item.vehicle_no,
                    type_truck: item.type_truck,
                }));
            });
        },


        loadTipeKejadian() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=kejad`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchTipeKejadian = response.data.datas;
            });
        },

        loadKerusakan() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=kerus`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchKerusakan = response.data.datas;
            });
        },

        loadPenyebabDasar() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=sebab`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchPenyebabDasar = response.data.datas;
            });
        },

        loadAccidentArea() {
            const baseURI =
                this.$settings.endPointCt + `branch`;
            return this.$http.get(baseURI).then((response) => {
                var resp = response.data.datas;
                for (let index = 0; index < resp.data.length; index++) {
                    const branch = resp.data[index].branch_name;
                    this.fetchAccidentArea.push(branch);
                }
                // var data={
                //   resp.data.branch_name
                // }
                //this.fetchAccidentArea = response.data.datas;
            });
        },

        asyncSearchDriverNmk(ev) {
            const baseURI =
                this.$settings.endPointCt + `master-driver?driver_id=` + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDriverNmk = response.data.datas.data;
            });
        },


        asyncSearchVehicleNo(ev) {
            const baseURI =
                this.$settings.endPointCt + `master-truck?vehicle_no=` + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchVehicleNo = response.data.datas.data;
            });
        },


        loadLoadId() {
            const baseURI = this.$settings.endPoint + `claim/get-data-loadid-claim`;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLoadId = response.data.datas.data;
                if (this.fetchLoadId.length == 0) {
                    this.$swal({
                        title: 'Confirm',
                        text: 'Load id tidak bisa di lanjutkan untuk proses claim, silahkan klik Yes untuk membuat claim baru dan Cancel untuk kembali ke BA ',
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes!",
                    }).then((result) => {
                        console.log(result.value);
                        if (result.value) {
                            window.location.href = "/claim/pengajuan/add";
                        } else {

                            window.location.href = "/request-ba";
                        }
                    });
                }
            });

        },


        loadordeNo(load_id) {
            const baseURI = this.$settings.endPoint + `claim/get-order-by-loadid/` + load_id;

            return this.$http.get(baseURI).then((response) => {
                this.orderNoList = response.data.datas;
            });

        },

        loadDriverDeposit(nmk_driver) {
            const baseURI = this.$settings.endPoint + `/claim/get-saldo-akhir-driver/` + nmk_driver;

            return this.$http.get(baseURI).then((response) => {
                let driver = response.data.datas;
                this.dataOrder.driver_deposit = driver?.saldo_akhir;
            });

        },

        tambahClaimFile() {
            this.lampiran.push({ nama: '', file: null });
        },
        hapusClaimFile(index) {
            this.lampiran.splice(index, 1);
        },
        onFileChange(event, index) {
            const file = event.target.files[0];
            this.lampiran[index].file = file;
        },


        tambahOrder() {
            this.dataOrder.orders.push({
                orderNo: null,
                customerCode: '',
                customerName: '',
                sapCode: '',
                tanggalOrder: '',
                pickPlan: '',
                pickName: '',
                dropPlan: '',
                dropName: '',
                shipwith_ref: '',
                done: false
            });
        },

        hapusOrder(index) {
            this.dataOrder.orders.splice(index, 1);
        },
        pilihOrder(index, data) {

            this.dataOrder.orders[index].customerCode = data.code;
            this.dataOrder.orders[index].customerName = data.name;
            this.dataOrder.orders[index].sapCode = data.sap_code;
            this.dataOrder.orders[index].tanggalOrder = data.order_date;
            this.dataOrder.orders[index].pickPlan = data.pick_plan;
            this.dataOrder.orders[index].pickName = data.pick_name;
            this.dataOrder.orders[index].dropPlan = data.dest_plan;
            this.dataOrder.orders[index].dropName = data.dest_name;
            this.dataOrder.orders[index].shipwith_ref = data.shipwith_ref;
            console.log(this.dataOrder.orders);
        },

        asyncSearchLoadId(ev) {
            const baseURI = this.$settings.endPoint + `claim/get-data-loadid-claim?load_id=${ev}`;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLoadId = response.data.datas.data;
            });
        },

        openModal() {
            const baseURI = this.$settings.endPointCt + "blujay-order/select";
            this.$http
                .get(baseURI)
                .then((response) => {

                    this.dataModal = {
                        detail: response.data.datas
                    }
                    this.showModalUnloading = true;
                });
        },

        loadBlujay() {
            const baseURI = this.$settings.endPointCt + `blujay-order/select`;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLoadNumber = response.data.datas.data;
            });

        },

        asyncSearchLoadNumber(ev) {
            const baseURI = this.$settings.endPointCt + "blujay-order/select?load_id=" + ev;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLoadNumber = response.data.datas.data;
            });
        },



        // asyncSearchProvinsiTujuan() {
        //   const baseURI = this.$settings.endPoint + "postal-code/select-province/Indonesia";

        //   return this.$http.get(baseURI).then((response) => {
        //     this.fetchProvinsiTujuan = response.data.datas;
        //   });
        // },

        // "blujay_order_id",
        //       "load_number",
        //       "detail_order_id",
        //       "shipment_number",
        //       "shipment_date",
        //       "vehicle_no",
        //       "master_driver_id",
        //       "driver_nmk",
        //       "driver_name",
        //       "driver_hp",
        //       "tanggal_muat",
        //       "tanggal_bongkar",
        //       "provinsi_tujuan",
        //       "kota_tujuan",
        //       "sku",
        //       "route",
        //       "qty",
        //       "qty_return",
        //       "sub_customer",
        //       "description",

        // "blujay_order_id": 3539,
        //             "load_id": "60530857",
        //             "vehicle_no": "B9153FXS",
        //             "driver_nmk": null,
        //             "driver_name": null,
        //             "driver_hp": null,
        //             "name_rute": "pickup :LTLCIKARANG BARAT(GUDANG CML) - LTLLEGOK(PT JAYA SWARASA AGUNG TBK)",
        //             "drop": "LTLLEGOK(PT JAYA SWARASA AGUNG TBK)",
        //             "order_detail_id": 3515,
        //             "shipment_number": "2100437094",
        //             "shipment_date": "2000-01-01 01:01:01",
        //             "state_pick": "BT",
        //             "city": "TANGERANG",
        //             "region": "LEGOK",
        //             "state_drop": "BT",
        //             "vehicle_status": "ACTIVE",
        //             "driver_status": null,
        //             "route": "BT-BT",
        //             "leadtime": 1
        closeMyModal(ev) {
            console.log(ev.master_driver_id)
            if (ev !== null) {
                this.disabledBeforeLoad = false;
                this.forms.master_driver_id = ev.master_driver_id;
                this.forms.blujay_order_id = ev.blujay_order_id;
                this.forms.detail_order_id = ev.order_detail_id;
                this.forms.load_number = ev.load_id;

                this.vehicle_no = {
                    vehicle_no: ev.vehicle_no
                }

                this.forms.driver_nmk = ev.driver_nmk;
                this.forms.driver_name = ev.driver_name;
                this.forms.driver_hp = ev.driver_hp;
                this.forms.route = ev.name_rute;
                this.forms.shipment_number = ev.shipment_number;
                this.forms.shipment_date = ev.shipment_date;
                this.forms.tanggal_muat = ev.shipment_date;
                this.forms.order_number = ev.shipment_number;
                this.forms.driver_id = ev.driver_nmk;
                this.forms.vehicle_owner = ev.branch_name;
                this.driver_id = ev.driver_nmk;
                this.driver_nmk = ev.driver_nmk;



            }

            this.showModalUnloading = false;
        },

        removeReadonly() {
            this.$nextTick(() => {
                const input = this.$refs.inputtLoadId.$el.querySelector(
                    ".multiselect__input"
                );
                if (input && input.hasAttribute("readonly")) {
                    input.removeAttribute("readonly");
                }
            });
        },

        capitalize(value) {
            if (!value) return ''
            value = value.toLowerCase()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },



        isNumberLatLong(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        resetForm() {
            this.forms = "";
        },


        loadCategoriStatus() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=catclm`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchCategoryStatus = response.data.datas;

            });
        },


        loadtypePaket() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=clmtppk`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchTypePaket= response.data.datas;

            });
        },


        backForm() {

            this.$router.push({ name: 'pengajuan' });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },

        submitData() {
            this.isLoading = true;

           
            // Buat FormData
            var tglPengajuan = moment(this.dataKlaim?.tglPengajuan.startDate).format("YYYY-MM-DD HH:mm:ss");
            var tglKejadian = moment(this.dataKlaim?.tglKejadian.startDate).format("YYYY-MM-DD HH:mm:ss");
            let formData = new FormData();

            // Data utama (string / number)
            formData.append("load_id", this.dataOrder?.loadId?.load_id || '');
            formData.append("driver_number", this.dataOrder?.driver_number || '');
            formData.append("carrier", this.dataOrder?.carrier || '');
            formData.append("driver_nmk", this.dataOrder?.nmkDriver || '');
            formData.append("driver_name", this.dataOrder?.namaDriver || '');
            formData.append("truck_type", this.dataOrder?.type_truck || '');
            formData.append("vehicle_no", this.dataOrder?.nopol || '');
            formData.append("aging", this.dataKlaim?.aging || 0);
            formData.append("branch", this.dataOrder?.branch_name || '');
            formData.append("claim_date", tglPengajuan);
            formData.append("source_of_information", this.dataKlaim?.sumberInfo || '');
            formData.append("incident_report", this.dataKlaim?.laporan || '');
            formData.append("incident_result", this.dataKlaim?.pemeriksaan || '');
            formData.append("incident_settlement", this.dataKlaim?.penyelesaian || '');
            formData.append("incident_date", tglKejadian);
            formData.append("claim_total", this.totalKlaim || 0);
            formData.append("claim_driver", this.bebanDriver || 0);
            formData.append("claim_vendor", this.bebanVendor || 0);
            formData.append("claim_absorb", this.bebanKantor || 0);
            formData.append("claim_insurance", this.bebanAsuransi || 0);

            // ======================
            // Array claim_order
            // ======================
            let claim_order = [];

            (this.dataOrder?.orders || []).forEach((item) => {
                claim_order.push({
                    order_no: item.orderNo.order_no,
                    shipwith_reff: item.shipwith_ref,
                    customer_code: item.customerCode,
                    customer_name: item.customerName,
                    sap_code: item.sapCode,
                    order_date: item.orderNo.order_date,
                    pick_plan: item.pickPlan,
                    pick_name: item.pickName,
                    dest_plan: item.dropPlan,
                    dest_name: item.dropName
                });
            });
            console.log(this.dataOrder?.orders);
            claim_order.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    formData.append(`claim_order[${index}][${key}]`, item[key] ?? '');
                });
            });

            // ======================
            // Array claim_detail
            // ======================
            let claim_detail = [];
            (this.dataKlaim?.details || []).forEach((item) => {
                claim_detail.push({
                    product_id: item.product_id,
                    product_name: item.produk,
                    product_description: item.keterangan,
                    claim_to: item.klaimKe,
                    product_category: item.kategori,
                    package_qty: item.jumlah,
                    package_type: item.typePaket,
                    cost_per_package: item.harga,
                    total_cost_package: (item.harga || 0) * (item.jumlah || 0),
                });
            });

            claim_detail.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    formData.append(`claim_detail[${index}][${key}]`, item[key] ?? '');
                });
            });

          
            let claim_attachment = [];
            (this.lampiran || []).forEach((item) => {
                claim_attachment.push({
                    attachment_name: item.nama,
                    attachment_file: item.file,
                });
            });

            claim_attachment.forEach((item, index) => {
                formData.append(`claim_attachment[${index}][attachment_name]`, item.attachment_name || '');
                if (item.attachment_file) {
                    formData.append(`claim_attachment[${index}][attachment_file]`, item.attachment_file);
                }
            });

            console.log(this.dataKlaim);
            const baseURI = this.$settings.endPoint + "claim/pengajuan/create-new-claim";
            this.$http.post(baseURI, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 50000
            })
                .then((response) => {
                    this.isLoading = false;
                    if (response.data.status === 200) {
                        this.success('Berhasil');
                        var params = this.$onRandom(response.data.datas.claim_id);
                        window.location.href =
                            "/claim/pengajuan/detail/" + params + "?status=200&msg=Successfully";
                        this.errors = [];
                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else if (error.response) {
                        if (error.response.status === 422) {
                           
                            let errors = error.response.data.errors || {};

                           
                            let errorMessages = "";
                            Object.keys(errors).forEach(key => {
                                errors[key].forEach(msg => {
                                    errorMessages += `<li>${msg}</li>`;
                                });
                            });

                            this.$swal.fire({
                                icon: "error",
                                title: "Validation Error",
                                html: `<ul style="text-align:left;">${errorMessages}</ul>`,
                                confirmButtonText: "OK",
                            });
                        } else if (error.response.status === 500) {
                            this.error(error.response.data.errors.message);
                        } else {
                            this.$router.push("/page-not-found");
                        }
                    }
                });
        },



        fade(sType) {
            this.isLoading = sType;
        },

        changeDriverNmk(driver) {
            this.forms.driver_name = driver.driver_name;
            this.forms.driver_hp = driver.hp1;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == "ClaimPengajuanController") {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_create) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },



        loadDataBA(id) {

            const baseURI =
                this.$settings.endPointLincMobile + "web/m-berita-acara/detail-toh/" + id;
            return this.$http.get(baseURI).then((response) => {
                var forms = response.data.datas[0];
                console.log(this.forms.type_truck);
                // this.dataKlaim.namaDriver=forms.driver_name;
                // this.dataKlaim.type_truck=forms.type_truck;
                console.log(this.dataKlaim);
                this.dataOrder = {
                    loadId: {
                        load_id: forms.load_id,
                    },
                    type_truck: forms.type_truck,
                    nmkDriver: forms.driver_id,
                    driver_deposit: 0,
                    driver_number: forms?.driver_number,
                    nopol: forms.vehicle_no,
                    namaDriver: forms.driver_name,
                    carrier: forms?.carrier,
                    branch_name: forms?.branch_name,
                    orders: [

                    ]
                };

                this.loadordeNo(forms.load_id)
                if (forms.driver_nmk != null) {
                    this.loadDriverDeposit(forms.driver_nmk)
                }

                // (forms?.orders || []).forEach((item) => {
                //     this.dataOrder.orders.push({
                //         orderNo: {
                //             order_no: item.order_no,
                //         },
                //         shipwith_ref: item.shipwith_reff,
                //         customerCode: item.customer_code,
                //         customerName: item.customer_name,
                //         sapCode: item.sap_code,
                //         tanggalOrder: item.order_date,
                //         pickPlan: item.pick_plan,
                //         pickName: item.pick_name,
                //         dropPlan: item.dest_plan,
                //         dropName: item.dest_name
                //     });
                // });




                this.lampiran = [

                ];
                console.log(this.forms);
                this.lampiran.push({ nama: 'Berita Acara', file: null });
                (forms?.ba || []).forEach((item) => {
                    this.lampiran.push({ nama: item.name, file: item.value });
                });


                // this.loading();
                // this.rows = response.data.datas.data;
                // this.totalRecords = response.data.datas.total;
            });
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },
    },
    events: {},
    created: function () { },
    mounted() {

        const formElement = this.$refs.formElement;
        if (formElement) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                        const inputs = formElement.querySelectorAll('.multiselect__input');
                        inputs.forEach(input => {
                            input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                        });
                    }
                });
            });


            const inputs = formElement.querySelectorAll('.multiselect__input');
            inputs.forEach(input => {
                observer.observe(input, { attributes: true });
            });
        }

        this.loadLoadId()
        // this.loadAccidentArea();
        //this.loadCategory();
        // this.loadCause();
        // this.loadRate();
        this.loadCategoriStatus();
        this.loadtypePaket();
        this.fetchIt();
        // this.loadBlujay();
        // this.loadVehicleNo();
        // this.loadDriverNmk();
        // this.loadPenyebabLangsung();
        // this.loadCaseResult();
        // this.loadKerusakan();
        // this.loadTipeKejadian();
        // this.loadPenyebabDasar();
        // this.loadDirectCauseDetail();
        this.loadNmkDriver();
        this.loadNopol();
        this.loadSumberInformasi();
        const m_load_id = this.$route.query.m_load_id;

        if (m_load_id) {
            console.log(m_load_id);
            this.loadDataBA(m_load_id);
        }
    },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
    visibility: hidden;
}



.blur-content {
    filter: blur(5px);
    pointer-events: none;

}

.calendars[data-v-1ebd09d2] {
    display: -webkit-box;
    display: -ms-flexbox;
}

@media screen and (min-width:339px) {
    .daterangepicker.single[data-v-1ebd09d2] {
        min-width: auto
    }

    .daterangepicker.single.show-ranges.show-weeknumbers[data-v-1ebd09d2],
    .daterangepicker.single.show-ranges[data-v-1ebd09d2] {
        min-width: 360px !important
    }
}

.input-group>.form-control,
.input-group>.typeahead.tt-input,
.input-group>.typeahead.tt-hint,
.select2-container--default .select2-search--dropdown .input-group>.select2-search__field,
.input-group>.form-select {
    background: white;
}

.datetimepicker-c {
    height: 35px;
}
</style>